/**
 * Service category IDs that require professional license verification before
 * the provider is shown in customer discovery (after admin confirms documents).
 */
export const SKILL_CATEGORY_IDS_REQUIRING_LICENSE: readonly string[] = [
  'nurse_attendant',
  'physiotherapy_home',
  'physio_orthopedic',
  'physio_neurological',
  'physio_sports_injury',
  'physio_pediatric',
  'physio_geriatric',
  'physio_post_surgery',
  'physio_spine',
  'physio_knee_hip',
  'physio_shoulder_neck',
] as const;

export function skillCategoryRequiresLicense(skillCategoryId: string): boolean {
  return SKILL_CATEGORY_IDS_REQUIRING_LICENSE.includes(skillCategoryId);
}
